import { ethers } from 'ethers'

export const getBytesAddress = (recipient: string) => {
  try {
    return ethers.utils.solidityPack(['bytes'], [ethers.utils.toUtf8Bytes(recipient)])
  } catch (e) {
    return recipient
  }
}
